import { render, staticRenderFns } from "./ArtworkIntakeDetails.vue?vue&type=template&id=19907ec9&scoped=true&"
import script from "./ArtworkIntakeDetails.vue?vue&type=script&lang=js&"
export * from "./ArtworkIntakeDetails.vue?vue&type=script&lang=js&"
import style0 from "./ArtworkIntakeDetails.vue?vue&type=style&index=0&id=19907ec9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19907ec9",
  null
  
)

export default component.exports